export const recentInteractions = "/recent_interactions";
